import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithRetry, ENDPOINT_TAGS } from '../../store/rootApi';
import { MeGetResponse } from '../model/authModel';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: [ENDPOINT_TAGS.AUTH],
  endpoints: (builder) => ({
    getMe: builder.query<MeGetResponse, void>({
      query: () => '/api/me',
      providesTags: [ENDPOINT_TAGS.AUTH],
    }),
  }),
});

export const { useGetMeQuery } = authApi;
